const Cookies = require('js-cookie');

export default class TokenStore {
    public static get = function (): string {
        return  Cookies.get("rosht") || '';
    }

    public static set = function (value: string) {
        Cookies.set("rosht", value, {path: '/',expires: 180});
    }

    public static remove = function () {
        Cookies.remove("rosht");
    }
}
